module.exports = __webpack_public_path__ + "static/media/group52@2x.ed7b74e4.png";